/**
 * @description 首页相关接口
 * @author 有界前端团队
 * @date 2024-05-30
 */
import request from '@/utils/request'

/**
 * 获取首页配置信息
 * 包括分类树、推荐分类和轮播图
 * @returns {Promise<Object>} 首页配置信息
 */
export function requestHomeConfig() {
  return request({
    url: '/home/config',
    method: 'post'
  })
}

/**
 * 获取推荐商品列表
 * @param {Object} data - 请求参数
 * @param {number} data.categoryId - 分类ID
 * @returns {Promise<Object>} 推荐商品列表
 */
export function requestRecommendProducts(data) {
  return request({
    url: '/home/recommendProduct',
    method: 'post',
    data
  })
} 

/**
 * 获取首页配置信息
 * 包括分类树、推荐分类和轮播图
 * @returns {Promise<Object>} 首页配置信息
 */
export function requestKAHomeConfig() {
  return request({
    url: '/ka/home/config',
    method: 'post'
  })
}

/**
 * 获取推荐商品列表
 * @param {Object} data - 请求参数
 * @param {number} data.categoryId - 分类ID
 * @returns {Promise<Object>} 推荐商品列表
 */
export function requestKARecommendProducts(data) {
  return request({
    url: '/ka/home/recommendProduct',
    method: 'post',
    data
  })
} 

/**
 * 获取web配置
 * @returns 
 */
export function requestWebConfig(data) {
  return request({
    url: '/web/config',
    method: 'post',
    data
  })
}

/**
 * 获取客户配置
 * @returns 
 */
export function requestCustomerConfig(data) {
  return request({
    url: '/home/customerConfig',
    method: 'post',
    data
  })
}

// v2页面配置信息
export function requestHomeV2Config() {
  return request({
    url: '/home/v2/config',
    method: 'post'
  })
}

// 订单统计信息
export function requestOrderStatistics(data) {
  return request({
    url: '/home/orderStatistics',
    method: 'post',
    data
  })
}
